import { RESPONSE_TYPES } from "@constants/response-types";

import { HttpService } from "@services/http";
import {
  prepareErrorResponse,
  prepareResponseObject,
} from "@services/http/response";

export class UserProfileService extends HttpService {
  userProfile = async (
    baseAuthUrl: string,
    data: FormData,
  ): Promise<TObject> => {
    try {
      const headers: TObject = {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      };

      const apiResponse = await this.patch(
        `${baseAuthUrl}/api/user/profile`,
        data,
        { headers },
      );

      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
  uploadFile = async (
    baseAuthUrl: string,
    data: FormData,
    pid?: any,
  ): Promise<TObject> => {
    try {
      const headers: TObject = {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      };
      const url = pid
        ? `${baseAuthUrl}/api/file/upload?project_id=${pid}`
        : `${baseAuthUrl}/api/file/upload`;
      const apiResponse = await this.post(url, data, { headers });

      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };

  fetchTourGuides = async (baseAuthUrl: string): Promise<TObject> => {
    try {
      const apiResponse = await this.get(`${baseAuthUrl}/api/tourguide`);
      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };

  submitTourCompletion = async (
    baseAuthUrl: string,
    data: { tourGuides: Array<{ type: number; isDone: boolean }> },
  ): Promise<TObject> => {
    try {
      const headers: TObject = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      const apiResponse = await this.post(
        `${baseAuthUrl}/api/tourguide`,
        data,
        { headers },
      );

      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
}
